<!-- 期間外を選んだ時のエラー文 -->
<template>
  <!-- ※発売対象期間ではありません。 -->
  <div v-if="!is_date_limited_in" class="error-block">
    {{ $t("TicketStoreTicketing.cantSelectOutOfTerm") }}
  </div>
  <!-- 期間外を選んだ時のエラー文 -->
</template>

<script>
export default {
  name: "PurchaseStartedatError",
  props: {
    is_date_limited_in: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.error-block {
  margin: 0 0 10px 0;
  font-size: 13px;
  font-weight: bold;
  text-align: right;
  line-height: 17px;
  color: #ff3333;
}
</style>
